import {createSelector} from 'reselect';
import {getListingSummary} from './listingSummary';
import {getFirstPayment, getPriceLabels, getTotals, getPriceDetails} from './priceDetails';
import {getIsMobile, getDeviceSize, getSiteName} from './system';
import {
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen
} from './modalStates';
import {getBookingType, getTakesInquiries} from './listing';
import {getTripDataDates} from './tripDates';
import {getAbacusTests} from './store';
import {VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY} from '../abacus/experiments';
import {evaluationIsVariant} from '@homeaway/react-experiment';
import {getPriceTransparencyTestOn} from './primaryCallToActionButton';
import {getReviewRating} from './reviews';

const getViewDetailsTotalData = createSelector(
    [getPriceDetails, getPriceLabels, getTotals, getTripDataDates, getPriceTransparencyTestOn],
    (priceDetails, labels, totals, dates, isMobilePriceTransparencyEnabled) => ({
        edapPriceQuotePresented: priceDetails.edapPriceQuotePresented,
        labels,
        showViewDetailsLink: !!(totals || {}).totalWithoutDeposits,
        totals,
        datesAreSet: Boolean(dates && dates.arriveDateText && dates.departDateText),
        isMobilePriceTransparencyEnabled
    })
);

const getRightRailData = createSelector(
    [
        getBookingType,
        getListingSummary,
        getViewDetailsTotalData,
        getSiteName,
        isDatePickerModalOpen,
        isGuestSelectorModalOpen,
        isRequestToBookModalOpen,
        isInquiryModalOpen,
        getTakesInquiries,
        getFirstPayment,
        getIsMobile,
        getAbacusTests,
        getDeviceSize,
        getPriceDetails,
        getReviewRating
    ],
    (
        bookingType,
        listingSummary,
        viewDetailsTotalData,
        siteName,
        datePickerPopoverOpen,
        guestSelectorPopoverOpen,
        requestToBookModalOpen,
        inquiryModalOpen,
        takesInquiries,
        firstPaymentData,
        isMobile,
        abacusTests,
        deviceSize,
        priceDetails,
        {reviewCount, webRatingBadges}
    ) => {
        const consolidate =
            deviceSize !== 'sm' &&
            !isMobile &&
            evaluationIsVariant(abacusTests[VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY], 1);

        return {
            listingSummaryData: listingSummary,
            viewDetailsTotalData,
            siteName,
            datePickerPopoverOpen,
            guestSelectorPopoverOpen,
            requestToBookModalOpen,
            inquiryModalOpen,
            showSecondaryAction: bookingType.onlineBookable && takesInquiries,
            firstPaymentData,
            consolidate,
            currencyConversionLabel: priceDetails.currencyConversionLabel,
            reviewCount,
            webRatingBadges
        };
    }
);

export default getRightRailData;
export {getRightRailData, getViewDetailsTotalData};
